import React from 'react';
import './About.css'
const About = () => {
    return (
        <div>
            <div>
                <div data-aos="zoom-in-left" className="banner my-4">
                    <h2 className="text-center my-5 ">MADANG SUPPORT PAGE</h2>
                    <p className="text-muted text-center my-5" >Great men knew this truth. Life to them was action. This is the service of others. A life lived for selfish gains, regardless of others needs, is worse than death. A bird or a beast collects food for itself and its young ones. It is some kind of work no doubt, but it is not that kind of work that man is expected to do. He is the roof and crown of creation and so he is supposed to live a larger life by applying himself to the service of humanity.   <br />
                    </p>
                    <p className="text-muted text-center my-5"> God is omnipresent. He would stand before us everywhere. He would stand by a man in the temple. He will also stand by a man on the plough. As Rabindranath once said in one of his lyrics, God is with the farmer tilling his field, with the laborer laying the path.</p>
                    <br />
                    <p className="text-muted text-center my-5">
                        We should therefore spurn the age-old practice of searching for Him in the temple of bricks. If God is in me, He is in others too, in the rich and the proud as in the lowly and the lost. To stand on the dust and perspire in the service of others is thus to be in service of God Himself, to worship God in the true sense of the term.</p>
                </div>
            </div>
        </div >
    );
};

export default About;